export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const setToStorage = (name, value) => {
  localStorage.setItem(name, JSON.stringify(value));
};

export const getFromStorage = (name) => {
  return JSON.parse(localStorage.getItem(name));
};

export const removeFromStorage = (name) => {
  localStorage.removeItem(name);
};
